import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/experimental-nextjs-app-support/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_common/EarlyProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_common/LateProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_common/ProgressIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TransferTokens","TransferToStoreClient"] */ "/app/src/app/_common/TransferData.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/UIResource/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/promo/ApplyPromoColors/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/tagmanager/event/watchers.js");
